var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(-1042.5 -742.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M4478.361,6292.849v-22.432a4.782,4.782,0,0,0-4.782-4.782h-26.165a4.782,4.782,0,0,0-4.782,4.782v26.166a4.782,4.782,0,0,0,4.782,4.782h26.165a4.782,4.782,0,0,0,4.782-4.782v-3.453A1.285,1.285,0,0,0,4478.361,6292.849Zm-30.947-24.465h26.165a2.033,2.033,0,0,1,2.034,2.033v19.712l-3.72-2.964a3.663,3.663,0,0,0-4.471,0l-4.324,3.133a.917.917,0,0,1-1.191,0l-4.452-4.453a3.664,3.664,0,0,0-4.947-.2l-7.128,6.014v-21.241A2.034,2.034,0,0,1,4447.414,6268.384Zm26.165,30.232h-26.165a2.034,2.034,0,0,1-2.034-2.033v-1.331l8.905-7.464a.916.916,0,0,1,1.228,0l4.452,4.544a3.664,3.664,0,0,0,4.782.329l4.325-3.353a.917.917,0,0,1,1.117,0l5.424,4.353v2.922A2.033,2.033,0,0,1,4473.579,6298.616Zm-7.586-15.574a5.039,5.039,0,1,0-5.038-5.039A5.039,5.039,0,0,0,4465.993,6283.042Zm0-7.329a2.29,2.29,0,1,1-2.29,2.29A2.291,2.291,0,0,1,4465.993,6275.713Z",
    transform: "translate(-3398 -5521)",
    fill: "#3d4463"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 40,
    height: 40,
    transform: "translate(1042.5 742.5)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.ede30c5dfd4f0fc6309ccf1c6aeb1508.svg";
export { ForwardRef as ReactComponent };